import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SVGComponent = props => (
    <Svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <Path
            d="M13.1915 13.2197C14.2724 12.1346 14.9406 10.638 14.9406 8.98535C14.9406 5.67164 12.2543 2.98535 8.94055 2.98535C5.62684 2.98535 2.94055 5.67164 2.94055 8.98535C2.94055 12.2991 5.62684 14.9854 8.94055 14.9854C10.6016 14.9854 12.105 14.3104 13.1915 13.2197ZM13.1915 13.2197L17.0478 17.076"
            stroke={props.color ?? designSystem.colors.white}
            strokeWidth={1.5}
        />
    </Svg>
);
export default SVGComponent;
